import { DialogTitle } from "@headlessui/react";
import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";
import { useMediaQuery } from "react-responsive";

const url = "http://localhost:8080/api/";
function TranslatorDetails() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const [translatorsArray, setTranslatorArray] = useState([]);
    const [isLoadingPage, setIsLoadingPage] = useState(false);

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoadingPage(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.get(`${web_url}/api/auth/translators`, configToken)
                .then((response) => {
                    setTranslatorArray(response.data);
                    setIsLoadingPage(false);
                })
                .catch((err) => {
                    console.log("Error occurred");
                });
        }
    }, []);

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });

    const handleCloseError = () => {
        setOpenError(false);
        if (logDetails?.email === "admin@gmail.com") {
            navigate('/researcher/accounts/select')
        } else {
            if (isXlOrLarger) {
                navigate('/researcher/accounts/select');
            } else {
                navigate('/researcher/accounts/select');
            }
        }
    };

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();


    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} min-h-screen w-screen xl:pt-[20px]`}>

                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            if (logDetails?.email === "admin@gmail.com") {
                                navigate('/researcher/accounts/select')
                            } else {
                                navigate('/mobile/researcher/dashboard')
                            }

                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            if (logDetails?.email === "admin@gmail.com") {
                                navigate('/researcher/accounts/select')
                            } else {
                                navigate('/mobile/researcher/dashboard')
                            }
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            if (logDetails?.email === "admin@gmail.com") {
                                navigate('/researcher/accounts/select')
                            } else {
                                navigate('/desktop/researcher/dashboard')
                            }
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t421')}</p>
                    </div>
                </div>

                {isLoadingPage ?
                    <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                    :
                    <>
                        {
                            translatorsArray.length > 0 ? <>
                                <div className="mt-[10px] md:mt-[20px] xl:hidden pb-[100px]">
                                    {
                                        translatorsArray.map((request, index) => (
                                            <div className="mt-[10px] md:mt-[15px] flex items-center justify-between px-[20px] ml-[20px] mr-[10px] md:ml-[100px] md:mr-[100px] lg:ml-[140px] lg:mr-[140px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                                <div className="md:hidden flex flex-col">
                                                    <p className="text-[#8189B0] text-[12px] font-bold">{request.userFullName.length > 30
                                                        ? `${request.userFullName.slice(0, 25)}...`
                                                        : request.userFullName}</p>
                                                    <p className="text-[#8189B0] text-[12px] ">{request.userEmail.length > 30
                                                        ? `${request.userEmail.slice(0, 25)}...`
                                                        : request.userEmail}</p>
                                                    <p className="text-[#8189B0] text-[12px] ">{request.contactNumber}</p>
                                                </div>
                                                <div className="hidden md:flex flex-col">
                                                    <p className="text-[#8189B0] text-[15px] font-bold">{request.userFullName.length > 35
                                                        ? `${request.userFullName.slice(0, 45)}...`
                                                        : request.userFullName}</p>
                                                    <p className="text-[#8189B0] text-[15px] ">{request.userEmail.length > 35
                                                        ? `${request.userEmail.slice(0, 45)}...`
                                                        : request.userEmail}</p>
                                                    <p className="text-[#8189B0] text-[15px] ">{request.contactNumber}</p>
                                                </div>
                                                <div className="flex flex-col gap-[5px]">
                                                    <button onClick={() => {
                                                        localStorage.setItem('t-id', request.userEmail);
                                                        navigate('/researcher/translator/view')
                                                    }} className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t207')}</button>
                                                    <button onClick={() => {
                                                        localStorage.setItem('t-schools', JSON.stringify(request.schoolIds));
                                                        localStorage.setItem('t-userId', request.id);
                                                        navigate('/researcher/translator/school')
                                                    }} className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t33_1')}</button>
                                                    {/* <button onClick={() => handleDenyDeleteAccountReq(request.userEmail, index)} className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t124')}</button> */}
                                                </div>
                                            </div>

                                        ))
                                    }
                                </div>

                                <div className="mt-[10px] hidden xl:grid grid-cols-3 pb-[50px] ml-[80px] mr-[70px]">
                                    {
                                        translatorsArray.map((request, index) => (
                                            <div key={index} className="mt-[10px] flex items-center justify-between px-[20px] ml-[10px] mr-[5px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                                <div className="2xl:hidden flex flex-col">
                                                    <p className="text-[#8189B0] text-[14px] 2xl:text-[13px] font-bold">{request.userFullName.length > 30
                                                        ? `${request.userFullName.slice(0, 25)}...`
                                                        : request.userFullName}</p>
                                                    <p className="text-[#8189B0] text-[15px] 2xl:text-[13px] ">{request.userEmail.length > 30
                                                        ? `${request.userEmail.slice(0, 25)}...`
                                                        : request.userEmail}</p>
                                                    <p className="text-[#8189B0] text-[14px] 2xl:text-[13px] ">{request.contactNumber}</p>
                                                </div>
                                                <div className="hidden 2xl:flex flex-col">
                                                    <p className="text-[#8189B0]  2xl:text-[14px] font-bold">{request.userFullName.length > 30
                                                        ? `${request.userFullName.slice(0, 30)}...`
                                                        : request.userFullName}</p>
                                                    <p className="text-[#8189B0]  2xl:text-[17px] ">{request.userEmail.length > 30
                                                        ? `${request.userEmail.slice(0, 30)}...`
                                                        : request.userEmail}</p>
                                                    <p className="text-[#8189B0] 2xl:text-[17px] ">{request.contactNumber}</p>
                                                </div>
                                                <div className="flex flex-col gap-[5px]">
                                                    <button onClick={() => {
                                                        localStorage.setItem('t-id', request.userEmail);
                                                        navigate('/researcher/translator/view')
                                                    }}
                                                        className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t207')}</button>
                                                    <button onClick={() => {
                                                        localStorage.setItem('t-schools', JSON.stringify(request.schoolIds));
                                                        localStorage.setItem('t-userId', request.id);
                                                        navigate('/researcher/translator/school')
                                                    }}
                                                        className="bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t33_1')}</button>
                                                    {/* <button onClick={() => handleDenyDeleteAccountReq(request.userEmail, index)} className="mt-[5px] bg-[#FFBEA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t124')}</button> */}
                                                </div>
                                            </div>

                                        ))
                                    }
                                </div>

                            </> : <>
                                <div className="flex  justify-center pt-[40px] font-bold text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[17px]"><p>{t('t125')}</p></div>
                            </>
                        }
                    </>
                }
            </div>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm mr-[30px] md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px]'>Account deleted succesfully</div>
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    Close
                                </Button>
                            </div>
                        </DialogContent>
                    }

                    {
                        isLoading &&
                        <DialogContent></DialogContent>
                    }

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TranslatorDetails;
